import React, { useEffect, useState } from "react";
import useSave from "../../Hooks/useSave";
import useFetch from "../../Hooks/useFetch";
import useDelete from "../../Hooks/useDelete";
import Table from "./../../Components/Table";
import { Link } from "react-router-dom";
import Modal from "react-awesome-modal";
import Api from "../../Hooks/Api";
const SelfAppraisal = (props) => {
  const [open, setOpen] = useState(false);
  const [inputs, setInputs] = useState({});
  const [view, setview] = useState(false);
  const [selfAppraisal, setSelfAppraisal] = useState(true);
  const [contractsOptions, setContractsOptions] = useState([]);
  const [ratingsOptions, setRatingOptions] = useState([]);
  const [update, setUpdate] = useState(false);
  const url = "api/staff-appraisals";
  const { state, FetchAll } = useFetch(url);

  const fetchContracts = async () => {
    try {
      Api.get("/api/contracts")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setContractsOptions(data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };
  const fetchRatings = async () => {
    try {
      Api.get("/api/performance-rating-scale")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setRatingOptions(data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };
  useEffect(() => {
    FetchAll();
    fetchContracts();
    fetchRatings();
  }, []);

  const handleOpenModal = (event) => {
    event.persist();
    setInputs({});
    setOpen(true);
  };

  const handleInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setInputs((inputs) => ({ ...inputs, [name]: value }));
  };

  const handleEdit = () => {
    if (inputs.appraisalId) {
      setOpen(true);
      setUpdate(true);
      setview(false);
    } else {
      alert("Select a record to edit");
    }
  };
  const handleSup = () => {
    if (inputs.appraisalId) {
      setOpen(true);
      setUpdate(true);
      setview(false);
      setSelfAppraisal(false);
    } else {
      alert("Select a record to edit");
    }
  };
  const handleView = () => {
    if (inputs.appraisalId) {
      setview(true);
      setUpdate(false);
      setOpen(true);
    } else {
      alert("Select a record to veiw");
    }
  };
  const handleSelect = (k, event) => {
    setInputs({});
    setInputs(k);
  };
  const handleCloseModal = () => {
    setOpen(false);
    setview(false);
  };

  const HandleSubmit = (event) => {
    event.preventDefault();
    useSave(url, inputs);
  };
  const CallDeletehook = () => {
    useDelete(url + "/delete?id=" + inputs.appraisalId);
  };
  const HandelDelete = () => {
    if (inputs.appraisalId) {
      CallDeletehook();
    } else {
      alert("Select a record to delete");
    }
  };
  const ColumnData = [
    {
      label: "Id",
      field: "appraisalId",
      sort: "asc",
    },
    {
      label: "Contract",
      field: "contract",
      sort: "asc",
    },
    {
      label: "Financial Year",
      field: "financialYear",
      sort: "asc",
    },
    {
      label: "Staff QTR1",
      field: "staff_QTR1",
      sort: "asc",
    },
    {
      label: "Staff QTR2",
      field: "staff_QTR2",
      sort: "asc",
    },
    {
      label: "Staff QTR3",
      field: "staff_QTR3",
      sort: "asc",
    },
    {
      label: "Staff QTR4",
      field: "staff_QTR4",
      sort: "asc",
    },
    {
      label: "Sup QTR1",
      field: "sup_QTR1",
      sort: "asc",
    },
    {
      label: "sup QTR2",
      field: "sup_QTR2",
      sort: "asc",
    },
    {
      label: "sup QTR3",
      field: "sup_QTR3",
      sort: "asc",
    },
    {
      label: "sup QTR4",
      field: "sup_QTR4",
      sort: "asc",
    },
  ];
  let Rowdata1 = [];
  const rows = state.data;
  if (rows.length > 0) {
    rows.forEach((k) => {
      const Rowdata = {
        clickEvent: () => handleSelect(k),
        contract: k.contract?.staff?.fullName,
        financialYear: k.contract?.financialYear?.name,
        staff_QTR1: k.staff_QTR1,
        appraisalId: k.appraisalId,
        staff_QTR2: k.staff_QTR2,
        staff_QTR3: k.staff_QTR3,
        staff_QTR3: k.staff_QTR3,
        staff_QTR4: k.staff_QTR4,
        sup_QTR1: k.sup_QTR1,
        sup_QTR2: k.sup_QTR2,
        sup_QTR3: k.sup_QTR3,
        sup_QTR4: k.sup_QTR4,
      };
      Rowdata1.push(Rowdata);
    });
  }

  return (
    <div id="content" className="content">
      <ol class="breadcrumb float-xl-right">
        <li class="breadcrumb-item">
          {" "}
          <Link to="/">Home </Link>{" "}
        </li>
        <li class="breadcrumb-item active">Staff KPI Appraisal</li>
      </ol>
      <h1 class="page-header mb-3">Staff KPI Appraisal</h1>
      <div style={{ backgroundColor: "white" }}>
        <div className="row">
          <div class="col-sm-12 d-flex flex-row float-right">
            &nbsp; &nbsp; &nbsp;
            <button
              onClick={handleOpenModal}
              className="btn btn-primary p-2"
              style={{ marginRight: 5, marginTop: 5 }}
            >
              New
            </button>
            <button
              onClick={handleView}
              className="btn btn-success p-2"
              style={{ marginRight: 5, marginTop: 5 }}
            >
              View
            </button>
            <button
              onClick={handleEdit}
              className="btn btn-info p-2"
              style={{ marginRight: 5, marginTop: 5 }}
            >
              Edit
            </button>
            <button
              onClick={handleSup}
              className="btn btn-info p-2"
              style={{ marginRight: 5, marginTop: 5 }}
            >
              Supervisor appraisal
            </button>
            <button
              onClick={HandelDelete}
              className="btn btn-danger p-2"
              style={{ marginRight: 5, marginTop: 5 }}
            >
              Delete
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <Table Rows={Rowdata1} columns={ColumnData} />
          </div>
        </div>
      </div>

      <Modal visible={open} width="70%" height="85%" effect="fadeInUp">
        <div style={{ "overflow-y": "auto", height: "100%" }}>
          <a className="close" onClick={() => handleCloseModal()}>
            &times;
          </a>

          <div className="row">
            <div className="col-sm-5"></div>
            {view ? null : (
              <div className="col-sm-4 fontWeight-bold text-blue">
                Staff KPI Appraisal
              </div>
            )}
          </div>
          <div className="container-fluid">
            <div className="col-sm-12">
              <div className="ibox-content">
                <br />

                {view ? (
                  <div>
                    <h3>Staff KPI Appraisal</h3>
                    <table className="table table-sm">
                      <tbody>
                        <tr>
                          <td className="font-weight-bold">Contract:</td>
                          <td>{inputs.contract.staff.fullName}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Financial Year:</td>
                          <td>{inputs.contract.financialYear.name}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Staff QTR1:</td>
                          <td>{inputs.staff_QTR1}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Staff_QTR2:</td>
                          <td>{inputs.staff_QTR2}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Staff QTR3:</td>
                          <td>{inputs.staff_QTR3}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Staff QTR4:</td>
                          <td>{inputs.staff_QTR4}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Sup QTR1:</td>
                          <td>{inputs.sup_QTR1}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Sup QTR2:</td>
                          <td>{inputs.sup_QTR2}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">sup_QTR3:</td>
                          <td>{inputs.sup_QTR3}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Sup QTR4:</td>
                          <td>{inputs.sup_QTR4}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">
                            staff Total Score:
                          </td>
                          <td>{inputs.staffTotalScore}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Sup Total Score:</td>
                          <td>{inputs.supTotalScore}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Staff Remarks:</td>
                          <td>{inputs.staffRemarks}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">
                            Supervisor Remarks:
                          </td>
                          <td>{inputs.supervisorRemarks}</td>
                        </tr>
                      </tbody>
                    </table>
                    <br />
                    <div className="row">
                      <div class="d-flex flex-row ">
                        <button
                          className="btn btn-primary p-2"
                          type="button"
                          onClick={handleEdit}
                        >
                          Update
                        </button>
                        &nbsp;
                        <button
                          onClick={HandelDelete}
                          className="btn btn-danger p-2"
                        >
                          Delete
                        </button>
                        &nbsp;
                        <button
                          className="btn btn-warning p-2"
                          type="button"
                          onClick={handleCloseModal}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                    <br />
                  </div>
                ) : (
                  <form className="form-horizontal" onSubmit={HandleSubmit}>
                    <div>
                      <div className=" row">
                        <div className="col-sm">
                          <div className="form-group">
                            <label
                              htmlFor="Datereceived"
                              className="fontWeight-bold"
                            >
                              Contract
                            </label>
                            <select
                              className="form-control"
                              name="contractId"
                              required
                              value={inputs.contractId || ""}
                              onChange={handleInputChange}
                              disabled={!selfAppraisal}
                            >
                              <option value="">Select contractId</option>
                              {contractsOptions &&
                                contractsOptions.map((types) => (
                                  <option
                                    key={types.contractId}
                                    value={types.contractId}
                                  >
                                    {types.staff.fullName +
                                      "-" +
                                      types.financialYear.name}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-sm">
                          <div className="form-group">
                            <label
                              htmlFor="Datereceived"
                              className="fontWeight-bold"
                            >
                              Staff QTR1 Score
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              name="staff_QTR1"
                              required
                              value={inputs.staff_QTR1}
                              disabled={!selfAppraisal}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-sm">
                          <div className="form-group">
                            <label
                              htmlFor="Datereceived"
                              className="fontWeight-bold"
                            >
                              Staff QTR2 Score
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              name="staff_QTR2"
                              required
                              disabled={!selfAppraisal}
                              value={inputs.staff_QTR2}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                      </div>

                      <div className=" row">
                        <div className="col-sm">
                          <div className="form-group">
                            <label
                              htmlFor="Datereceived"
                              className="fontWeight-bold"
                            >
                              Staff QTR3 Score
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              name="staff_QTR3"
                              required
                              disabled={!selfAppraisal}
                              value={inputs.staff_QTR3}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-sm">
                          <div className="form-group">
                            <label
                              htmlFor="Datereceived"
                              className="fontWeight-bold"
                            >
                              Staff QTR4 Score
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              name="staff_QTR4"
                              required
                              disabled={!selfAppraisal}
                              value={inputs.staff_QTR4}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-sm">
                          <div className="form-group">
                            <label
                              htmlFor="Datereceived"
                              className="fontWeight-bold"
                            >
                              Staff Total Score
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              name="staffTotalScore"
                              required
                              disabled={!selfAppraisal}
                              value={inputs.staffTotalScore}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className=" row">
                        <div className="col-sm">
                          <div className="form-group">
                            <label
                              htmlFor="Datereceived"
                              className="fontWeight-bold"
                            >
                              Staff Remarks
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="staffRemarks"
                              required
                              disabled={!selfAppraisal}
                              value={inputs.staffRemarks}
                              onChange={handleInputChange}
                              // defaultvalue={inputs.name}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {!selfAppraisal ? (
                      <div>
                        <div className=" row">
                          <div className="col-sm">
                            <div className="form-group">
                              <label
                                htmlFor="Datereceived"
                                className="fontWeight-bold"
                              >
                                Rating
                              </label>
                              <select
                                className="form-control"
                                name="ratingId"
                                required
                                value={inputs.ratingId || ""}
                                onChange={handleInputChange}
                                disabled={selfAppraisal}
                              >
                                <option value="">Select rating</option>
                                {ratingsOptions &&
                                  ratingsOptions.map((types) => (
                                    <option
                                      key={types.ratingId}
                                      value={types.ratingId}
                                    >
                                      {types.gradeName}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-sm">
                            <div className="form-group">
                              <label
                                htmlFor="Datereceived"
                                className="fontWeight-bold"
                              >
                                Supervisor QTR1 Score
                              </label>
                              <input
                                type="number"
                                className="form-control"
                                name="sup_QTR1"
                                required
                                disabled={selfAppraisal}
                                value={inputs.sup_QTR1}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                          <div className="col-sm">
                            <div className="form-group">
                              <label
                                htmlFor="Datereceived"
                                className="fontWeight-bold"
                              >
                                Supervisor QTR2 Score
                              </label>
                              <input
                                type="number"
                                className="form-control"
                                name="sup_QTR2"
                                required
                                disabled={selfAppraisal}
                                value={inputs.sup_QTR2}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                        </div>
                        <div className=" row">
                          <div className="col-sm">
                            <div className="form-group">
                              <label
                                htmlFor="Datereceived"
                                className="fontWeight-bold"
                              >
                                Supervisor QTR3 Score
                              </label>
                              <input
                                type="number"
                                className="form-control"
                                name="sup_QTR3"
                                required
                                disabled={selfAppraisal}
                                value={inputs.sup_QTR3}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                          <div className="col-sm">
                            <div className="form-group">
                              <label
                                htmlFor="Datereceived"
                                className="fontWeight-bold"
                              >
                                Supervisor QTR4 Score
                              </label>
                              <input
                                type="number"
                                className="form-control"
                                name="sup_QTR4"
                                required
                                disabled={selfAppraisal}
                                value={inputs.sup_QTR4}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                          <div className="col-sm">
                            <div className="form-group">
                              <label
                                htmlFor="Datereceived"
                                className="fontWeight-bold"
                              >
                                Supervisor Total Score
                              </label>
                              <input
                                type="number"
                                className="form-control"
                                name="supTotalScore"
                                required
                                disabled={selfAppraisal}
                                value={inputs.supTotalScore}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                        </div>
                        <div className=" row">
                          <div className="col-sm">
                            <div className="form-group">
                              <label
                                htmlFor="Datereceived"
                                className="fontWeight-bold"
                              >
                                Supervisor Remarks
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="supervisorRemarks"
                                required
                                disabled={selfAppraisal}
                                value={inputs.supervisorRemarks}
                                onChange={handleInputChange}
                                // defaultvalue={inputs.name}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    <div className="row">
                      <div className="col-sm">
                        <div className="row">
                          <div className="col-sm-12">
                            <div class="d-flex flex-row">
                              {update ? (
                                <button
                                  className="btn btn-primary p-2"
                                  type="submit"
                                >
                                  Update
                                </button>
                              ) : (
                                <button
                                  className="btn btn-primary p-2"
                                  type="submit"
                                >
                                  Submit
                                </button>
                              )}
                              &nbsp;
                              <button
                                className="btn btn-warning p-2"
                                type="button"
                                onClick={handleCloseModal}
                              >
                                Close
                              </button>
                            </div>
                            <br />
                          </div>
                        </div>
                        <br />
                      </div>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};
export default SelfAppraisal;
